import { apiClient } from '@/plugins/axios';

const sendWhatsAppWithMediaKit = async (whatsapps: any) => {
  return await apiClient.post('/', whatsapps);
};

const sendEmailWithMediaKit = async (emails: any) => {
    return await apiClient.post('/email/send-media-kit', emails);
  };

export default {
    sendWhatsAppWithMediaKit,
    sendEmailWithMediaKit
};
